import React, { useRef, useEffect, useState } from "react";
import "./scrollup.css";

const ScrollUp = () => {
  const scrollUpRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // ✅ Update state based on scroll position
      setIsVisible(window.scrollY >= 560);
    };

    // ✅ Add listener once on mount
    window.addEventListener("scroll", handleScroll, { passive: true });

    // ✅ Cleanup listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty deps = run once

  return (
    <a
      href="/#"
      className={`scrollup ${isVisible ? "show-scroll" : ""}`}
      ref={scrollUpRef}
    >
      <i className="bx bx-up-arrow-alt scrollup__icon"></i>
    </a>
  );
};

export default ScrollUp;
